var GridEvents;

(function (GridEvents) {
  GridEvents["resize"] = "resize";
  GridEvents["debouncedResize"] = "debouncedResize";
  GridEvents["viewportInnerSizeChange"] = "viewportInnerSizeChange";
  GridEvents["componentError"] = "componentError";
  GridEvents["unmount"] = "unmount";
  GridEvents["cellModeChange"] = "cellModeChange";
  GridEvents["cellClick"] = "cellClick";
  GridEvents["cellDoubleClick"] = "cellDoubleClick";
  GridEvents["cellMouseDown"] = "cellMouseDown";
  GridEvents["cellMouseUp"] = "cellMouseUp";
  GridEvents["cellKeyDown"] = "cellKeyDown";
  GridEvents["cellFocusIn"] = "cellFocusIn";
  GridEvents["cellFocusOut"] = "cellFocusOut";
  GridEvents["cellDragEnter"] = "cellDragEnter";
  GridEvents["cellDragOver"] = "cellDragOver";
  GridEvents["editCellPropsChange"] = "editCellPropsChange";
  GridEvents["cellEditCommit"] = "cellEditCommit";
  GridEvents["cellEditStart"] = "cellEditStart";
  GridEvents["cellEditStop"] = "cellEditStop";
  GridEvents["rowEditStart"] = "rowEditStart";
  GridEvents["rowEditStop"] = "rowEditStop";
  GridEvents["rowEditCommit"] = "rowEditCommit";
  GridEvents["cellNavigationKeyDown"] = "cellNavigationKeyDown";
  GridEvents["rowClick"] = "rowClick";
  GridEvents["rowDoubleClick"] = "rowDoubleClick";
  GridEvents["rowMouseEnter"] = "rowMouseEnter";
  GridEvents["rowMouseLeave"] = "rowMouseLeave";
  GridEvents["editRowsModelChange"] = "editRowsModelChange";
  GridEvents["columnHeaderBlur"] = "columnHeaderBlur";
  GridEvents["columnHeaderFocus"] = "columnHeaderFocus";
  GridEvents["columnHeaderNavigationKeyDown"] = "columnHeaderNavigationKeyDown";
  GridEvents["columnHeaderKeyDown"] = "columnHeaderKeyDown";
  GridEvents["columnHeaderClick"] = "columnHeaderClick";
  GridEvents["columnHeaderDoubleClick"] = "columnHeaderDoubleClick";
  GridEvents["columnHeaderOver"] = "columnHeaderOver";
  GridEvents["columnHeaderOut"] = "columnHeaderOut";
  GridEvents["columnHeaderEnter"] = "columnHeaderEnter";
  GridEvents["columnHeaderLeave"] = "columnHeaderLeave";
  GridEvents["columnHeaderDragStart"] = "columnHeaderDragStart";
  GridEvents["columnHeaderDragOver"] = "columnHeaderDragOver";
  GridEvents["columnHeaderDragEnter"] = "columnHeaderDragEnter";
  GridEvents["columnHeaderDragEnd"] = "columnHeaderDragEnd";
  GridEvents["selectionChange"] = "selectionChange";
  GridEvents["headerSelectionCheckboxChange"] = "headerSelectionCheckboxChange";
  GridEvents["rowSelectionCheckboxChange"] = "rowSelectionCheckboxChange";
  GridEvents["pageChange"] = "pageChange";
  GridEvents["pageSizeChange"] = "pageSizeChange";
  GridEvents["rowGroupingModelChange"] = "rowGroupingModelChange";
  GridEvents["rowsScroll"] = "rowsScroll";
  GridEvents["rowsScrollEnd"] = "rowsScrollEnd";
  GridEvents["columnSeparatorMouseDown"] = "columnSeparatorMouseDown";
  GridEvents["columnResize"] = "columnResize";
  GridEvents["columnWidthChange"] = "columnWidthChange";
  GridEvents["columnResizeStart"] = "columnResizeStart";
  GridEvents["columnResizeStop"] = "columnResizeStop";
  GridEvents["columnOrderChange"] = "columnOrderChange";
  GridEvents["rowsSet"] = "rowsSet";
  GridEvents["rowExpansionChange"] = "rowExpansionChange";
  GridEvents["visibleRowsSet"] = "visibleRowsSet";
  GridEvents["columnsChange"] = "columnsChange";
  GridEvents["detailPanelsExpandedRowIdsChange"] = "detailPanelsExpandedRowIdsChange";
  GridEvents["pinnedColumnsChange"] = "pinnedColumnsChange";
  GridEvents["pipeProcessorRegister"] = "pipeProcessorRegister";
  GridEvents["pipeProcessorUnregister"] = "pipeProcessorUnregister";
  GridEvents["activeStrategyProcessorChange"] = "activeStrategyProcessorChange";
  GridEvents["strategyAvailabilityChange"] = "strategyAvailabilityChange";
  GridEvents["sortModelChange"] = "sortModelChange";
  GridEvents["filterModelChange"] = "filterModelChange";
  GridEvents["columnVisibilityModelChange"] = "columnVisibilityModelChange";
  GridEvents["stateChange"] = "stateChange";
  GridEvents["columnVisibilityChange"] = "columnVisibilityChange";
  GridEvents["virtualScrollerContentSizeChange"] = "virtualScrollerContentSizeChange";
  GridEvents["preferencePanelClose"] = "preferencePanelClose";
  GridEvents["preferencePanelOpen"] = "preferencePanelOpen";
})(GridEvents || (GridEvents = {}));

export { GridEvents };